module.exports = __webpack_public_path__ + "img/southeast3.a8219675.jpg";